import {
    Column,
    Entity,
    Index,
    JoinColumn,
    JoinTable,
    ManyToMany,
    ManyToOne,
    PrimaryGeneratedColumn,
} from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IBuilding } from './interface/IBuilding';
import { IRanking } from './interface/IRanking';
import { IRefRankingDisposition } from './interface/IRefRankingDisposition';
import { IRefRankingEstablishment } from './interface/IRefRankingEstablishment';
import { IRefRankingHouseFamily } from './interface/IRefRankingHouseFamily';
import { IRefRankingHouseHome } from './interface/IRefRankingHouseHome';
import { IRefRankingOrigin } from './interface/IRefRankingOrigin';
import { IRefRankingType } from './interface/IRefRankingType';
import { ITechnicalFile } from './interface/ITechnicalFile';
import { IVerification } from './interface/IVerification';
import { RefRankingOrigin } from './RefRankingOrigin';

@Entity('ranking')
export class Ranking extends BaseEntity implements IRanking {
    apiMapping = {
        id: 'extId',
        localId: 'id',
        buildingId: 'buildingId',

        // buildingId: {
        //     type: 'Building',
        //     fieldName: 'building',
        //     map: true,
        // },
        refRankingEstablishmentId: {
            type: 'RefRankingEstablishment',
            fieldName: 'refRankingEstablishment',
        },
        rankingCategory: 'rankingCategory',
        rankingOriginRefRankingOriginId: {
            type: 'RefRankingOrigin',
            fieldName: 'rankingOriginRefRankingOrigin',
        },
        rankingOriginTechnicalFile: {
            type: 'TechnicalFile',
            fieldName: 'rankingOriginTechnicalFile',
            map: true,
            mapType: 'one',
        },
        rankingOriginFullname: 'rankingOriginFullName',
        rankingOriginOther: 'rankingOriginOther',
        rankingGlobalNumberOperator: 'rankingGlobalNumberOperator',
        rankingGlobalNumberValue: 'rankingGlobalNumberValue',
        rankingPublicNumberOperator: 'rankingPublicNumberOperator',
        rankingPublicNumberValue: 'rankingPublicNumberValue',
        workforceOriginRefRankingOriginId: {
            type: 'RefRankingOrigin',
            fieldName: 'workforceOriginRefRankingOrigin',
        },
        workforceOriginTechnicalFile: {
            type: 'TechnicalFile',
            fieldName: 'workforceOriginTechnicalFile',
            map: true,
            mapType: 'one',
        },
        workforceOriginCivility: 'workforceOriginCivility',
        workforceOriginFullname: 'workforceOriginFullName',
        workforceOriginOther: 'workforceOriginOther',
        activityTopics: 'activityTopics',
        refRankingHouseFamilyId: {
            type: 'RefRankingHouseFamily',
            fieldName: 'refRankingHouseFamily',
        },
        refRankingHouseHomeId: {
            type: 'RefRankingHouseHome',
            fieldName: 'refRankingHouseHome',
        },
        isHouseErp: 'isHouseErp',
        houseErpDetails: 'houseErpDetails',
        hasCarPark: 'hasCarPark',
        refRankingTypes: {
            type: 'RefRankingType',
            fieldName: 'refRankingType',
        },
        refRankingDisposition: {
            type: 'RefRankingDisposition',
            fieldName: 'refRankingDisposition',
            map: false,
            mapToApi: true,
            mapType: 'many',
        },
    };

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    @Index()
    extId: number;

    @Column({ nullable: true })
    rankingCategory: string;

    @Column({ nullable: true })
    rankingOriginFullName: string;

    @Column({ nullable: true })
    rankingOriginOther: string;

    @Column({ nullable: true })
    rankingGlobalNumberOperator: string;

    @Column({ nullable: true })
    rankingGlobalNumberValue: number;

    @Column({ nullable: true })
    rankingPublicNumberOperator: string;

    @Column({ nullable: true })
    rankingPublicNumberValue: number;

    @Column({ nullable: true })
    workforceOriginCivility: string;

    @Column({ nullable: true })
    workforceOriginFullName: string;

    @Column({ nullable: true })
    workforceOriginOther: string;

    @Column({ nullable: true })
    activityTopics: string;

    @Column({ nullable: true })
    isHouseErp: boolean;

    @Column({ nullable: true })
    houseErpDetails: string;

    @Column({ nullable: true })
    hasCarPark: boolean;

    @ManyToOne('Verification', 'rankings')
    @JoinColumn()
    verification: IVerification;

    @ManyToMany('RefRankingDisposition')
    @JoinTable()
    refRankingDisposition: IRefRankingDisposition[];

    @ManyToMany('RefRankingType')
    @JoinTable()
    refRankingType: IRefRankingType[];

    @ManyToOne('RefRankingEstablishment')
    @JoinColumn()
    refRankingEstablishment: IRefRankingEstablishment;

    @ManyToOne('RefRankingOrigin')
    @JoinColumn()
    rankingOriginRefRankingOrigin: IRefRankingOrigin;

    @ManyToOne('TechnicalFile')
    @JoinColumn()
    rankingOriginTechnicalFile: ITechnicalFile;

    @ManyToOne('RefRankingOrigin')
    @JoinColumn()
    workforceOriginRefRankingOrigin: IRefRankingOrigin;

    @ManyToOne('TechnicalFile')
    @JoinColumn()
    workforceOriginTechnicalFile: ITechnicalFile;

    @ManyToOne('RefRankingHouseFamily')
    @JoinColumn()
    refRankingHouseFamily: IRefRankingHouseFamily;

    @ManyToOne('RefRankingHouseHome')
    @JoinColumn()
    refRankingHouseHome: IRefRankingHouseHome;

    @Column({ nullable: true })
    buildingId: number;

    building: IBuilding;

    selectedRankingEstablishmentId: number;
    selectedRankingDispositionIds: number[] = [];
    selectedRankingTypeIds: number[] = [];
    refRankingOrigins: RefRankingOrigin[];
    origin_name: number;
    workforceOriginRefRankingOrigin_name: number;
    refRankingHouseFamily_name: any;
    refRankingHouseHome_name: any;
    rDisposition: string;
    rType: string;
}
